// test1179
(1179 && 0);
